import { render, staticRenderFns } from "./CreateSearchAds.vue?vue&type=template&id=4b86d05b&scoped=true"
import script from "./js/create_search_ads.js?vue&type=script&lang=js&external"
export * from "./js/create_search_ads.js?vue&type=script&lang=js&external"
import style0 from "./CreateSearchAds.vue?vue&type=style&index=0&id=4b86d05b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b86d05b",
  null
  
)

export default component.exports